import {Stack} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {
	EmptyStateContainer,
	IconContainer,
	StyledButton,
	StyledDescription,
	StyledTitle,
} from './styles';
import type {AddTherapyEmptyStateProps} from './types';

const {addTherapy, emptyState} = translations['pt-br'].privateFlow.refund.therapies;
const {addTherapiesForRefund, line1, line2} = emptyState;

export const AddTherapyEmptyState = ({onAddTherapy}: AddTherapyEmptyStateProps) => (
	<EmptyStateContainer>
		<IconContainer>
			<Icon name="add-filled" size={48} color="currentColor" />
		</IconContainer>
		<Stack spacing={1} alignItems="center" maxWidth={918}>
			<StyledTitle>{addTherapiesForRefund}</StyledTitle>
			<StyledDescription>
				{line1}
				<br />
				{line2}
			</StyledDescription>
		</Stack>
		<StyledButton variant="outlined" color="primary" onClick={onAddTherapy}>
			{addTherapy}
		</StyledButton>
	</EmptyStateContainer>
);
